function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { AddressManualType } from 'swag-client-common/constants';
import { getCountryByCode } from 'swag-common/utils/shipping';
import { COUNTRY_CODES } from 'swag-common/constants/shipping.constants';
import classes from './address-block.scss';
export default class AddressBlock extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "getHeader", () => {
      const {
        addressEntity,
        isComparing
      } = this.props;
      if (!isComparing) {
        return null;
      }
      return /*#__PURE__*/React.createElement("span", {
        className: classes.header
      }, addressEntity.addressType === AddressManualType.ADDRESS_ENTERED ? 'Entered Address:' : 'Suggested Address:');
    });
    _defineProperty(this, "handleAddressClick", () => {
      const {
        addressEntity,
        onAddressClick
      } = this.props;
      onAddressClick(addressEntity.addressType);
    });
    _defineProperty(this, "getAddressRows", row => {
      const {
        address,
        city,
        state,
        unit,
        country,
        zip,
        addressType
      } = row;
      const isUSA = country === COUNTRY_CODES.US;
      const street = `${address} ${unit || ''}`;
      return isUSA ? {
        street,
        city: `${city} ${state} ${zip}`,
        type: addressType
      } : {
        street,
        city: `${city} ${state} ${zip} ${getCountryByCode(country)}`,
        type: addressType
      };
    });
  }
  render() {
    const {
      addressEntity,
      chosenAddress,
      activeBorderClassName
    } = this.props;
    const {
      street,
      city,
      type
    } = this.getAddressRows(addressEntity);
    return /*#__PURE__*/React.createElement("div", {
      key: type,
      className: classes.container,
      onClick: this.handleAddressClick
    }, this.getHeader(), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.item, {
        [classes.selected]: chosenAddress === type,
        // @todo. auto generated. fix this error
        // @ts-ignore
        [activeBorderClassName]: chosenAddress === type
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.row
    }, street), /*#__PURE__*/React.createElement("div", {
      className: classes.row
    }, city)));
  }
}